import { managementDialogStyles, managementFieldStyles } from "../../../styles/managementStyles";
import React, { useEffect, useRef, useState } from "react";
import { Grid, Modal } from '@mui/material';
import { Box } from "@mui/material";
import Titulo from "../../../components/Titulo";
import styled from "styled-components";
import Botao from "../../../components/Botao";
import autenticaStore from "../../../stores/autentica.store";
import { useForm } from "react-hook-form";
import http from "../../../http";
import { GridRowId } from "@mui/x-data-grid";
import IProduto, { UnidadeDuracaoAcesso } from "../../../types/IProduto";
import Precificacao from "../../Precificacao";
import { mostrarMensagem } from "../../../stores/mensagem.store";


const BoxCustomizado = styled(Box)`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80vw;
    max-height: 90vh;
    overflow-y: auto;
    background-color: #fffdfa;
    border: none;
    border-radius: 12px;
    padding: 1em 5em;
    ${managementDialogStyles}
`;

const Campo = styled.input`
    font-size: 15px;
    background: #f0f0f0;
    margin-top: 3px;
    margin-bottom: 25px;
    box-sizing: border-box;
    box-shadow: none;
    border-radius: 12px;
    border: none;
    width: 100%;
    padding: 10px;
    ${managementFieldStyles}
`
const BotaoCustomizado = styled(Botao)`
    width: 50%;
    display: block;
    margin: 0 auto;
`

const Rotulo = styled.label`
    display: block;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #35252b
`

const SpanErro = styled.span`
    float: left;
    color: #b3261e;
    font-size: 14px;
    margin-top: -25px;
`

const PrecificacaoWrapper = styled.div`
    margin-top: 8px;
`;

interface IProdutoPost {
    id: string,
    origem: string,
    nome: string,
    descricao: string,
    regras: string,
    duracaoAcessoQuantidade: number | null,
    duracaoAcessoUnidade: UnidadeDuracaoAcesso | null
}

interface IProdutoForm {
    origem: string;
    nome: string;
    descricao: string;
    regras: string;
    semExpiracao: boolean;
    duracaoAcessoQuantidade?: number;
    duracaoAcessoUnidade: UnidadeDuracaoAcesso | "";
}

const valoresIniciais: IProdutoForm = {
    origem: "",
    nome: "",
    descricao: "",
    regras: "",
    semExpiracao: true,
    duracaoAcessoQuantidade: undefined,
    duracaoAcessoUnidade: "",
};

export default function ModalProduto({ open, handleClose, produtos, id, tipo }: { open: boolean, handleClose: () => void, produtos: IProduto[], id: GridRowId[], tipo: string}) {
    const [idProduto, setIdProduto] = useState("");
    const {register, handleSubmit, reset, formState:{errors}, watch} = useForm<IProdutoForm>({
        defaultValues: valoresIniciais,
    });
    const semExpiracao = watch("semExpiracao");
    const initializedFormRef = useRef<string | null>(null);
    const {usuario} = autenticaStore;
    
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${usuario.token}`,
        },
    };
      
    useEffect(() => {
        if (!open) {
            initializedFormRef.current = null;
            setIdProduto("");
            reset(valoresIniciais);
            return;
        }
        const formKey = `${tipo}:${String(id[0] ?? "")}`;
        if (initializedFormRef.current === formKey) return;
        initializedFormRef.current = formKey;
        if (tipo === "edita") {
            const prod = produtos.find(item => String(item.id) === String(id[0]));
            setIdProduto(prod?.id == null ? "" : String(prod.id));
            reset({
                origem: prod?.origem ?? "",
                nome: prod?.nome ?? "",
                descricao: prod?.descricao ?? "",
                regras: prod?.regras ?? "",
                semExpiracao: prod?.duracaoAcessoQuantidade == null && prod?.duracaoAcessoUnidade == null,
                duracaoAcessoQuantidade: prod?.duracaoAcessoQuantidade ?? undefined,
                duracaoAcessoUnidade: prod?.duracaoAcessoUnidade ?? "",
            });
            return;
        }
        setIdProduto("");
        reset(valoresIniciais);
    }, [open, tipo, id, produtos, reset]);

    function postProduto(data: IProdutoForm) {
        const produto: IProdutoPost = {
            id: idProduto,
            origem: data.origem,
            nome: data.nome,
            descricao: data.descricao,
            regras: data.regras,
            duracaoAcessoQuantidade: data.semExpiracao ? null : Number(data.duracaoAcessoQuantidade),
            duracaoAcessoUnidade: data.semExpiracao || !data.duracaoAcessoUnidade
                ? null
                : data.duracaoAcessoUnidade,
        };
        const request = tipo === "cadastra"
            ? http.post("produtos", produto, axiosConfig)
            : http.put("produtos", produto, axiosConfig);
        request.then(() => {
            mostrarMensagem(tipo === "cadastra" ? "registro cadastrado com SUCESSO!" : "Alteração efetuada com sucesso!", "success");
            reset(valoresIniciais);
            handleClose();
        }).catch(erro => {
            mostrarMensagem("ERRO:" + erro, "error");
        });
    }

    const Close =() => {
        reset(valoresIniciais)
        handleClose()   
    }

    return (
        <>
            <Modal
                open={open}
                onClose={() => Close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                
            >
                <BoxCustomizado role="dialog" aria-label="Produto">
                    <form onSubmit={handleSubmit(postProduto)}>
                        <Titulo>{`${tipo === 'cadastra' ? "Cadastrar" : "Editar"} Produto`}</Titulo>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={2}>
                                <Rotulo htmlFor="produto-origem">Origem</Rotulo>
                                <Campo id="produto-origem" type="text" placeholder="" maxLength={100} {...register('origem', {required: "Campo obrigatório"})} />
                                {errors.origem && typeof errors.origem.message === 'string' && <SpanErro>{errors.origem.message}</SpanErro>}
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Rotulo htmlFor="produto-nome">Nome</Rotulo>
                                <Campo id="produto-nome" type="text" placeholder="" maxLength={100} {...register('nome', {required: "Campo obrigatório"})} />
                                {errors.nome && typeof errors.nome.message === 'string' && <SpanErro>{errors.nome.message}</SpanErro>}
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Rotulo htmlFor="produto-descricao">Descrição</Rotulo>
                                <Campo id="produto-descricao" type="text" placeholder="" maxLength={100} {...register('descricao', {required: "Campo obrigatório"})} />
                                {errors.descricao && typeof errors.descricao.message === 'string' && <SpanErro>{errors.descricao.message}</SpanErro>}
                            </Grid>
                            <Grid item xs={12} md={12} style={{marginTop: "-30px"}}>
                                <Rotulo htmlFor="produto-regras">Regras (Separar com ";") A regra deve ter seu valor cadastrado na tabela de taxas para ser calculada corretamente</Rotulo>
                                <Campo id="produto-regras" type="text" placeholder="" maxLength={100} {...register('regras')} />
                                {errors.regras && typeof errors.regras.message === 'string' && <SpanErro>{errors.regras.message}</SpanErro>}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <label>
                                    <input type="checkbox" {...register("semExpiracao")} />
                                    Sem expiração
                                </label>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Rotulo htmlFor="duracao-acesso-quantidade">Duração do acesso</Rotulo>
                                <Campo
                                    id="duracao-acesso-quantidade"
                                    type="number"
                                    min={1}
                                    step={1}
                                    disabled={semExpiracao}
                                    {...register("duracaoAcessoQuantidade", {
                                        valueAsNumber: true,
                                        validate: (value, formValues) =>
                                            formValues.semExpiracao ||
                                            (Number.isInteger(value) && Number(value) > 0) ||
                                            "Informe um número inteiro positivo",
                                    })}
                                />
                                {errors.duracaoAcessoQuantidade?.message && <SpanErro>{errors.duracaoAcessoQuantidade.message}</SpanErro>}
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Rotulo>Unidade</Rotulo>
                                <select
                                    aria-label="Unidade da duração"
                                    disabled={semExpiracao}
                                    {...register("duracaoAcessoUnidade", {
                                        validate: (value, formValues) =>
                                            formValues.semExpiracao || value !== "" || "Selecione uma unidade",
                                    })}
                                >
                                    <option value="">Selecione</option>
                                    <option value="DIA">Dia(s)</option>
                                    <option value="MES">Mês(es)</option>
                                    <option value="ANO">Ano(s)</option>
                                </select>
                                {errors.duracaoAcessoUnidade?.message && <SpanErro>{errors.duracaoAcessoUnidade.message}</SpanErro>}
                            </Grid>
                            <Grid item xs={12} md={2} > 
                                <Rotulo>&nbsp;</Rotulo>
                            <BotaoCustomizado style={{
                                        marginBottom: "40px", 
                                        marginTop: "-44px", 
                                        marginLeft: "0px"}}>
                                            {`${tipo === 'cadastra' ? "Cadastrar" : "Salvar"}`}</BotaoCustomizado>
                            </Grid>
                        </Grid>                
                        {/* <pre>{output}</pre> */}
                    </form>
                    {tipo === 'cadastra' ? "" : (
                        <PrecificacaoWrapper>
                            <Precificacao idProd={idProduto} />
                        </PrecificacaoWrapper>
                    )}  
                </BoxCustomizado>
            </Modal >
        </>
    );
}